<template>
  <div class="box">
    <img class="activity-bg" src="../../../../static/model-bg37.jpg" alt="" />
    <div class="activity-time">
        <p v-if="status==2">活动倒计时：<span>{{ H }}</span> 时 <span>{{ M }}</span> 分 <span>{{ S }} </span> 秒</p>
        <p v-if="status==1">活动尚未开始</p>
        <p v-if="status==0">活动已下线</p>
        <p v-if="status==3">活动已结束</p>
      </div>
    <div class="activity-content">
      
      <div >充<span>{{materialParamsDTO.materialParamsDetailDTOList[0].rechargeMoney}}</span>多送<span>{{materialParamsDTO.materialParamsDetailDTOList[0].giveAwayMoney}}</span></div>
      <p>共得{{materialParamsDTO.materialParamsDetailDTOList[0].totalbookCoin}}书币</p>
       <button v-if="status==2" @click="goTopay">立即充值</button>
      <button v-else class="default-btn">立即充值</button>
    </div>
    <div class="activity-tip">
      <p>活动规则</p>
      <p>1、活动时间：即日起至<span v-if="endTime">{{endTime}}</span></p>
      <p>2、本次活动
        <span v-if="purchaseLimitDTO.purchaseLimitType==2">参与次数不限</span>
        <span v-if="purchaseLimitDTO.purchaseLimitType==1">每天仅限参与{{purchaseLimitDTO.purchaseLimitValue}}次</span>
        <span v-if="purchaseLimitDTO.purchaseLimitType==0">每人仅限参与{{purchaseLimitDTO.purchaseLimitValue}}次</span>
      </p>
      <p>3、此充值为书币充值，一经充值不支持退款</p>
    </div>
  </div>
</template>
<script>
export default {
   props:['status','materialParamsDTO','endTime','purchaseLimitDTO','H','M','S'],
  data() {
    return {
    };
  },
  watch:{
    materialParamsDTO:{
        handler: function (val) {
         console.log(val)
        },
        deep: true
    },
    purchaseLimitDTO:{
       handler: function (val) {
         console.log(val)
        },
        deep: true
    },
  },
  methods:{
    goTopay(){
      this.$emit('payActivity',this.materialParamsDTO.materialParamsDetailDTOList[0])
    }
  }
};
</script>
<style scoped>
.box {
  position: relative;
}
.activity-bg {
  width: 100%;
  display: block;
}

.activity-time{
  font-size: 15px;
color: #333333;
text-align: center;
position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(162px + env(safe-area-inset-top));
  width: 240px;
height: 33px;
background-image: linear-gradient(180deg, #FEF1DD 0%, #FFE4A2 100%);
border-radius: 7px;
line-height: 33px;
} 
.activity-time span{
  color: #E53434;
}
.activity-content {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(212px + env(safe-area-inset-top));
box-sizing: border-box;
width: 340px;
height: 205px;
  background-image: linear-gradient(180deg, #FFF7CB 0%, #FFCB8F 100%);
border-radius: 15px;
padding:20px 0px;
}
.activity-content > div {
  font-size: 28px;
  color: #333333;
  text-align: center;
  font-weight: bold;
}
.activity-content > div > span {
  color: #E31A0B;
  font-size: 34px;
}
.activity-content > p {
  text-align: center;
  color: #E31A0B;
  font-size: 18px;
  margin-top: 23px;
  margin-bottom: 20px;
  line-height: 28px;
}
.activity-content > button {
  font-size: 20px;
  color: #FFEEB9;
  text-align: center;
  line-height: 47px;
  width: 210px;
height: 47px;
background: #ED2727;
border-radius: 8px;
  border: none;
  margin: 0 auto;
  display: block;

}
.activity-content > button.default-btn{
background: #969696;
color: #505050;
}
.activity-tip {
  position: absolute;
  bottom: 125px;
  left: 50%;
  transform: translateX(-50%);
}
.activity-tip p:nth-of-type(1) {
  text-align: center;
  margin-bottom: 6px;
  font-size: 14px;
}
.activity-tip p {
    white-space: nowrap;
  font-size:12px;
  color:  #FFFFFF;
  line-height:20px;
}
</style>



// WEBPACK FOOTER //
// src/view/bookModelActivity/compontent/modelthirtyseven.vue